document.addEventListener('DOMContentLoaded', () => {
  // header mobile switch
  (function () {
    const mobileSwitchElement = document.querySelector('.header__switch');
    if (!mobileSwitchElement) return;

    const BODY_CLASSNAME = '-open-menu';
    const OPEN_SWITCH_CLASSNAME = '-open';

    const htmlElement = document.documentElement;
    const pageElement = document.querySelector('.b-page');

    mobileSwitchElement.addEventListener('click', function (evt) {
      evt.preventDefault();

      htmlElement.classList.toggle('mx-overflow_hidden');
      pageElement.classList.toggle(BODY_CLASSNAME);

      if (htmlElement.classList.contains('safari')) {
        if (!mobileSwitchElement.classList.contains(OPEN_SWITCH_CLASSNAME)) {
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          htmlElement.style.setProperty('--scroll-y', `${-scrollY}px`);

          pageElement.style.position = 'fixed';
          pageElement.style.top = `${-scrollY}px`;

          mobileSwitchElement.classList.add(OPEN_SWITCH_CLASSNAME);
        } else {
          const scrollY = parseFloat(pageElement.style.top || '0') * -1;
          pageElement.style.position = '';
          pageElement.style.top = '';
          window.scrollTo(0, scrollY);

          mobileSwitchElement.classList.remove(OPEN_SWITCH_CLASSNAME);
        }
      } else {
        mobileSwitchElement.classList.toggle(OPEN_SWITCH_CLASSNAME);
      }
    });
  })();
})
